var routerList = [
  'refactor-main',
  //"my-info",
  'expense-list',
  'expense-claim-list',
  'pay-to-me-list',
  'receipt-fold',
  'expense-claim-detail',
  'applicationList',
  'loan-application-list',
  'loan-application-detail',
  'loan-bill-others',
  'workflow-list',
  'credit-list', //信用部分
  'credit-detail', //信用部分
  'application-detail',
  'payee-detail',
  'application-manage',
  'invoice-bag-list',
  'business-card-list',
  'invoice-info-list',
  'subsidy-calculation',
  'claim-setting-template-list',
  'report-entry',
  'cost-center-report',
  'department-report',
  'budget-report',
  'personal-report',
  // 'department-budget-report',
  'mile-list-v3',
  'payment-requisition-list',
  'payment-requisition-detail',
  'corp-payment-list',
  'corp-payment-detail',
  'my-calendar',
  'budget-journal-detail',
  'contract-list',
  'contract-detail',
  'loan-bill-list',
  'salary-payment-detail',
  'total-List-salary',
  'accrual-list',
  'accrual-detail',
  // 'expense-list-claim'
  'my-document',
  // 'travel-card-particulars',
  'quick-trip',
  'quick-trip-approval',
  'new-flyback-refactor',
  'project-refactor',
  'agent-detail',
];
export default { value: routerList.join() };
